import styled from '@emotion/styled'

import { Content, ContentContainerStyles } from '@cash-web/support/ui-components'

const HelpContent = styled(Content)`
  ${ContentContainerStyles}
`

export default HelpContent
